// Gastos de Traslados — paid service line items of type "Traslado" (id 11) in
// the period, by performed_at. One row per line item, with the line description
// (origen/destino), car (placa/marca/modelo/año), provider, invoice folio and
// amounts (sin IVA / IVA / con IVA).
import supabase from "../../../supabase-client";

const fmtMoney = (v) => "$" + Math.round(Number(v) || 0).toLocaleString("es-MX");

export const trasladoExpensesReport = {
  id: "traslado-expenses",
  title: "Gastos de Traslados",
  description:
    "Gastos de traslados pagados en el periodo, por fecha, con auto, descripción (origen/destino), proveedor, factura e importes.",
  category: "Operaciones",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
  ],
  summary: [
    { type: "count", label: "Traslados" },
    { type: "sum", label: "Total (con IVA)", valueKey: "total", valueFormat: fmtMoney },
    { type: "sum", label: "Subtotal (sin IVA)", valueKey: "subtotal", valueFormat: fmtMoney },
    { type: "groupBy", label: "Por Proveedor", key: "proveedor", valueKey: "total", valueFormat: fmtMoney,
      format: (v) => v ?? "Sin proveedor" },
  ],
  columns: [
    { key: "fecha", label: "Fecha" },
    { key: "placa", label: "Placa" },
    { key: "marca", label: "Marca" },
    { key: "modelo", label: "Modelo", width: 160, truncate: true },
    { key: "anio", label: "Año" },
    { key: "descripcion", label: "Descripción (origen/destino)", width: 320, truncate: true },
    { key: "proveedor", label: "Proveedor", width: 180, truncate: true },
    { key: "factura", label: "Factura", width: 140, truncate: true },
    { key: "subtotal", label: "Sin IVA", format: fmtMoney, exportType: "currency" },
    { key: "iva", label: "IVA", format: fmtMoney, exportType: "currency" },
    { key: "total", label: "Total", format: fmtMoney, exportType: "currency" },
  ],
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase.rpc("report_traslado_expenses", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
